import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/[0.06] mt-32">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5 flex flex-col gap-6">
        <div className="flex items-center gap-3">
          <Logo size={40} />
          <span className="font-display font-bold text-xl">
            Kuro<span className="text-[#FF2A55]">Pulse</span>
          </span>
        </div>
        <p className="text-[#94A3B8] max-w-sm leading-relaxed text-sm">
          Your own anime streaming library. Watch your favourite anime anywhere, anytime — with subtitles, seasons and
          resume.
        </p>
      </div>
      <div className="md:col-span-3 flex flex-col gap-3">
        <span className="kp-eyebrow">Navigate</span>
        <Link to="/" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Home</Link>
        <Link to="/browse" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Browse Catalog</Link>
      </div>
      <div className="md:col-span-4 flex flex-col gap-3">
        <span className="kp-eyebrow">Stack</span>
        <div className="flex flex-wrap gap-2">
          {["React", "FastAPI", "MongoDB", "MP4 Streaming", "Object Storage"].map((t) => (
            <span key={t} className="kp-pill cursor-default">{t}</span>
          ))}
        </div>
      </div>
    </div>
    <div className="border-t border-white/[0.06]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#64748B] font-mono">
        <span>© {new Date().getFullYear()} KUROPULSE — PERSONAL STREAMING</span>
        <span>UPLOAD ONLY CONTENT YOU OWN OR HAVE RIGHTS TO</span>
      </div>
    </div>
    <div className="pointer-events-none select-none absolute -bottom-6 right-0 font-display font-black text-[18vw] leading-none kp-outline-text opacity-[0.07]">
      PULSE
    </div>
  </footer>
);
